$(document).ready(function () {
  // Scroll to Top button
  $(".scroll-to-top").click(function (e) {
      e.preventDefault(); // Prevents the default button behavior
      $("html, body").animate({ scrollTop: 0 }, 1000);
  });
  
  // Show/hide button on scroll
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 300) {
      $(".go-to-top").fadeIn(); // Use jQuery to fade in
    } else {
      $(".go-to-top").fadeOut(); // Use jQuery to fade out
    }
  });
  
  // Go to Top button
  $(".go-to-top").click(function (e) {
      e.preventDefault(); // Prevents the default button behavior
      $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  // Variant Changed Event
  document.addEventListener('variants:change', (event) => {
    const variant = event.detail.variant; // Extract the variant data from the event
    // console.log('Variant changed:', variant);
  });

  sizeGuideTabInit();
  reamazeAppChatInit();

});

function sizeGuideTabInit(){
  // Listen for changes on *any* radio input that switches units
  document.querySelectorAll('[custom-tab-content] [data-tab]').forEach(input => {
    input.addEventListener('change', (event) => {
      const selectedInput = event.target;
      const selectedUnit = selectedInput.value;

      // Find the nearest container for this specific size chart
      const sizeTabContainer = selectedInput.closest('[custom-tab-content]');
      if (!sizeTabContainer) return;

      // Hide all tables inside this popup
      const tables = sizeTabContainer.querySelectorAll('[data-content]');
      tables.forEach(table => {
        if (table.dataset.content === selectedUnit) {
          table.classList.remove('hidden');
        } else {
          table.classList.add('hidden');
        }
      });
    });
  });
}

function reamazeAppChatInit(){
  // Custom Trigger to open the Reamaze App Chat
  document.querySelectorAll('.help-chat-box [href="#"], .product-content-accordion [href="#"]').forEach(ele => {
    ele.addEventListener('click', (event) => {
      event.preventDefault();
      if(Reamaze){
        Reamaze.popup();
      }
    });
  });
}

// Swiper Slide Center Align Start
function slideCenterAlign(swiper) {
  const container = swiper.el;
  if (!container) return;

  const totalSlides = swiper.slides.length;
  let currentSlidesPerView = swiper.params.slidesPerView;

  if(!totalSlides && !currentSlidesPerView) return;

  const isScrollable = totalSlides < currentSlidesPerView;
  container.classList.toggle('slide-not-scrollable', isScrollable);
}
// Swiper Slide Center Align End


// Free Product Bar Start
$(document).ready(function(){
  $('.free-product-bar .free_pro_close').click(function(){
    closeFreeProBar();
  });
});

function closeFreeProBar() {
  let stickyHeader = document.querySelector('sticky-header');
  let freeProBar = document.querySelector('.free-product-bar');
  if (stickyHeader && freeProBar) {
    document.documentElement.style.setProperty('--header-height', stickyHeader.offsetHeight - freeProBar.offsetHeight + 'px');
    freeProBar.classList.add('hidden');
  }
}
// Free Product Bar End

document.addEventListener('quick:add:loaded', function(event) {
  initializeStampedFnBadges();
});

// Cart Update and check the Free Product Available in the Cart
document.addEventListener('cart:updated', function(event) {
  let cartJSON = event.detail;
  let source = event.detail.source;

  if(source == 'add-to-cart'){
    getCartJSON().then(cart => {
      freeproRemove(cart);
    });
  } else if(source == 'cart-change') {
    freeproRemove(cartJSON.data);
  }
  
  initializeStampedFnBadges();
  sizeGuideTabInit();
  reamazeAppChatInit();
});

function initializeStampedFnBadges(){
  // Stamped.io Badge Reinitiation
  if (typeof StampedFn !== "undefined" && typeof StampedFn.loadBadges === "function") {
    StampedFn.loadBadges();
  }
}

function freeproRemove(cartJSON) {
  // console.log('cartJSON', cartJSON);
  const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const freeItems = cartJSON.items.filter(item => item?.properties?._free_pro_handles);
  const removeUpdates = [];
  const removeItems = [];

  freeItems.forEach(freeItem => {
    const handles = freeItem.properties._free_pro_handles.split(',');
    const match = cartJSON.items.find(item => handles.includes(item.handle));
    if (!match) {
      removeUpdates.push({ id: freeItem.key, quantity: 0 });
      removeItems.push({ id: freeItem.id, quantity: 0 });
    }
  });

  if(removeItems.length > 0) {
    // console.log('removeItems',removeItems);
    // Loop through each variant ID
    removeItems.forEach((variant) => {
      const removeButton = document.querySelector(`cart-remove-button button[data-variant-id="${variant.id}"]`);
  
      if (!removeButton) {
        console.warn(`No remove button found for variant ID: ${variant.id}`);
        return;
      }
  
      const cartRemoveButton = removeButton.closest('cart-remove-button');
      const cartItems = removeButton.closest('cart-items') || removeButton.closest('cart-drawer-items');
  
      if (!cartItems) {
        console.warn(`No cart container found for variant ID: ${variant.id}`);
        return;
      }
  
      const index = cartRemoveButton?.dataset?.index;
  
      if (!index) {
        console.warn(`No index found for variant ID: ${variant.id}`);
        return;
      }
  
      // Call the updateQuantity function with quantity = 0 (removal)
      cartItems.updateQuantity(parseInt(index), 0);
    });
    
  } else {
    console.warn('No matching free items to remove');
  }
  
  // Handle countdown timers
  cartJSON.items
    .filter(item => item?.properties?._free_pro_mm)
    .forEach(item => {
      if (item?.properties?._free_pro_timer) {
        freeProCountdown(item.id, item.properties._free_pro_mm, item.properties._free_pro_ss);
      }
    });
}

// Paged Loaded Free Product Timer Start
document.addEventListener('DOMContentLoaded', function(event) {
  getCartJSON().then(cartJSON => {
    cartJSON.items
    .filter(item => item?.properties?._free_pro_mm)
    .forEach(item => {
      if (item?.properties?._free_pro_timer) {
        freeProCountdown(item.id, item.properties._free_pro_mm, item.properties._free_pro_ss);
      }
    });
  });
});


// Cart item coundown timer Start
// Initialize the countdown object if it doesn't already exist
window.countdown = window.countdown || {};

// Function to start a countdown timer for a given id, with specified minutes and seconds
function freeProCountdown(id, minutes, seconds) {
  // Check if there's already a timer running for this id
  if (window.countdown[id] !== null && window.countdown[id] !== undefined) {
    // console.log(`Countdown for ${id} is already running.`);
    return;
  }

  // Set the end time based on the provided minutes and seconds
  const totalMilliseconds = (minutes * 60 + seconds) * 1000;
  const endTime = new Date().getTime() + totalMilliseconds;

  // Function to update the countdown every second
  window.countdown[id] = setInterval(() => {
    const now = new Date().getTime();
    const timeRemaining = endTime - now;

    // Calculate minutes and seconds remaining
    const minutesLeft = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const secondsLeft = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Display the countdown
    // console.log(`Time left for ${id}: ${minutesLeft}m ${secondsLeft}s`);
    let target = document.getElementById(`countdown-${id}`);
    if(target != null && target != undefined){
      target.innerHTML = `${minutesLeft}m ${secondsLeft}s`;
    }

    getCartJSON().then(cart => {
      const itemExists = cart.items.find((item) => item.id === id);
      // console.log('itemExists', itemExists);
      if (!itemExists || cart.items.length === 0 || itemExists == undefined) {
        clearCountdown(id)
        // console.log(`Item with ID ${id} is not in the cart.`);
      } else {
        // console.log(`Item with ID ${id} is already in the cart.`);
      }
    });

    // Check if the countdown has ended
    if (timeRemaining < 0) {
      clearInterval(window.countdown[id]);
      window.countdown[id] = null; // Reset the timer for the given id
      // console.log(`Countdown for ${id} finished!`);
      if(target != null && target != undefined){
        target.innerHTML = "Expired.";
      }
    }
  }, 1000);
}

// Function to clear the countdown for a given id
function clearCountdown(id) {
  if (window.countdown[id] !== null && window.countdown[id] !== undefined) {
    clearInterval(window.countdown[id]);
    window.countdown[id] = null;
    // console.log(`Countdown for ${id} has been cleared.`);
  } else {
    // console.log(`No active countdown for ${id} to clear.`);
  }
}
// Cart item coundown timer End


const getCartJSON = async () => {
  try {
    const response = await fetch('/cart.js'); // Fetch cart data from Shopify's AJAX API
    const cartData = await response.json(); // Parse the JSON response
    return cartData; // Return the cart data for further use
  } catch (error) {
    console.error('Error fetching cart data:', error); // Handle any errors
  }
};


// Product Add to cart custom
async function addItemsToCart(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(formData),
    });

    const responseData = await response.json();

    if (!response.ok) {
      console.error('❌ Error adding to cart:', responseData);
      return { success: false, data: responseData };
    }

    // Dispatch product added event
    document.dispatchEvent(new CustomEvent('product:added', { detail: responseData, bubbles: true }));
    
    return { success: true, data: responseData };
  } catch (error) {
    console.error('❌ Network error:', error);
    return { success: false, data: null };
  }
}

// See in your size Chart Start
$(document).ready(function(){
 setTimeout(function () {
    $('.see-in-your-size-popup .inner-block .right-block .size a:first-child').trigger('click');
  }, 200);

  $(".see-in-your-size-popup .inner-block .right-block .size a" ).click(function(e) {
    e.preventDefault();

    var Size = $(this).text();

    $(".see-in-your-size-popup .inner-block .right-block button").empty();
    $(".see-in-your-size-popup .inner-block .right-block button").append("Select Size " + Size);

    // $(".tab-nav h3").not($(this)).removeClass("active");
    
    $('.see-in-your-size-popup .inner-block .right-block .size a').removeClass('active');
    $(this).addClass('active');
    var CurrentTab = $( this ).attr('id');
    var selectTab = '[select-id="'+ CurrentTab +'"]';

    $(".see-in-your-size-popup .inner-block .left-block img").hide();
    $(".see-in-your-size-popup .inner-block .right-block .content p").hide();
    $(selectTab).fadeIn('fast');
     // $('.article-block .article').slick('refresh');
  });

  $('.see-in-your-size-popup .right-block .selected-size').click(function(){
    var GetSize = $(".see-in-your-size-popup .inner-block .right-block .size a.active" ).text().replace('/', '-');
    $('fieldset .variant-button-wrapper .varaint-button-option input[value="'+GetSize+'"]').trigger('click');
    $('.see-in-your-size-popup .see-in-your-size-popup-close').trigger('click');
  });
});
// See in your size Chart End


// Static Page Faq Js 
$(document).ready(function() {
  $(".accordion-wrapper").find(".accordion-toggle").click(function() {
    $(this).next().slideToggle("slow"),
      $(this).toggleClass("active"),
      $(".accordion-content").not($(this).next()).slideUp("slow"),
      $(".accordion-toggle").not($(this)).removeClass("active")
  })
})
// Static Page Faq Js end


$(document).ready(function(){
  $('.MegaMenu .last_linkList.image a').hover(function (event) {
    event.preventDefault();
    $(this).addClass('active');
    $('.megamenu-image .MegaMenu__Push').hide();
    console.log("")
    $("."+$(this).attr('image')).show();
     $(".MegaMenu .last_linkList.image a").not($(this)).removeClass("active");
  });
  
  $( ".MegaMenu .last_linkList.image a" ).mouseleave (function() {  
    $('.MegaMenu .last_linkList.image a.active').removeClass( "active" ); 
    $('.megamenu-image .MegaMenu__Push').hide();
    
    $('.megamenu-image .MegaMenu__Push:first-child').show();
  });
});

$(document).ready(function(){   
  var main = document.querySelector('header-drawer');
  $('header-drawer .menu-block > .menu_links_wrap:first-child .navigate_arrow').click(function(){
    event.preventDefault();
    $("header-drawer .level1").css("display", "none");
    $("header-drawer .second-level .second-level-main").css("display", "block");
    $("header-drawer .second-level .second-level-main.second-level-main-new").css("display", "none");
    main.scrollTop = 0;
  });

  $('header-drawer .second-level .second-level-main .second-level-title').click(function(){
    $("header-drawer .second-level .second-level-main").css("display", "none");
    $("header-drawer .level1").css("display", "block");
    main.scrollTop = 0;
  });
  
  $('header-drawer .menu-block > .menu_links_wrap:last-child .navigate_arrow').click(function(){
    event.preventDefault();
    $("header-drawer .level1").css("display", "none");
    $("header-drawer .second-level .second-level-main").css("display", "none");
    $("header-drawer .second-level .second-level-main.second-level-main-new").css("display", "block");
    main.scrollTop = 0;
  });

  $('header-drawer .second-level .second-level-main.second-level-main-new .second-level-title').click(function(){
    $("header-drawer .second-level .second-level-main.second-level-main-new").css("display", "none");
    $("header-drawer .level1").css("display", "block");
    main.scrollTop = 0;
  });
});



// Cart Upsell Addtocart Start
document.addEventListener('DOMContentLoaded', () => {
  // Set up variant change listener
  document.querySelectorAll('.product-upsell-inner').forEach(container => {
    const select = container.querySelector('.upsell-variant-select');
    const button = container.querySelector('.upsell-add-btn');

    if (!select || !button) return;

    function updateButtonState() {
      const selectedOption = select.options[select.selectedIndex];
      const isAvailable = selectedOption.dataset.available === 'true';

      if (isAvailable) {
        button.textContent = 'Add';
        button.disabled = false;
        button.classList.remove('sold-out');
      } else {
        button.textContent = 'Sold';
        button.disabled = true;
        button.classList.add('sold-out');
      }
    }

    select.addEventListener('change', updateButtonState);
    updateButtonState(); // Initial run
  });

  // Add-to-cart logic with availability check
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.upsell-add-btn');
    if (!btn || btn.disabled) return;

    try {
      const container = btn.closest('.product-upsell-inner');
      const select = container.querySelector('.upsell-variant-select');
      const selectedOption = select.options[select.selectedIndex];

      const variantId = Number(selectedOption.value);
      const isAvailable = selectedOption.dataset.available === 'true';

      if (!isAvailable) {
        console.warn('Variant is unavailable.');
        return;
      }

      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const items = [{
        id: Number(variantId),
        quantity: 1,
      }];

      const formData = {
        items,
        sections: cartDrawer?.getSectionsToRender().map(section => section.id),
        sections_url: window.location.pathname,
      };

      const { success, data } = await addItemsToCart(formData);
      
      if (!success) return;
      console.log(success);
      console.log(data);
    
      // Optionally update cart drawer contents
      if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data);
      }

      console.log('Upsell product added!');
    } catch (err) {
      console.error('Error adding upsell product:', err);
    }
  });
});
// Cart Upsell Addtocart End


// Cart Timer Start
document.addEventListener('visibilitychange', function() {
  if (document.visibilityState === 'visible') {
    // console.log('Welcome back to the tab!');
    let cartDrawer = document.getElementById('sidebar-cart');
    if (cartDrawer) {
      let attributeValue = cartDrawer.getAttribute('aria-hidden');
      // console.log('Attribute value:', attributeValue);
      if (attributeValue == 'false') {
        startCountdownCart();
      }
    }
  }
});
document.addEventListener("cart:drawer:open",startCountdownCart,false);
document.addEventListener("cart:updated",startCountdownCart,false);

// let countdownDuration = 60; // Set initial countdown duration in seconds (e.g., 60 seconds = 1 minute)
let timerInterval = null; // Initialize the interval variable

function startCountdownCart() {
  let timerEle = document.getElementById('timer'); // or use document.getElementById('your-element-id');
  if(timerEle) {
    // console.log('element is available');
    // Check if there's already an existing timer running
    if (timerInterval) {
      clearInterval(timerInterval); // Clear the existing interval
      timerInterval = null;
    }

    // Reset the countdown duration if needed
    let startMinutes = 59;  // Example: 59 minutes
    let startSeconds = 52; // Example: 52 seconds
    let countdownDuration = startMinutes * 60 + startSeconds;

    // Start a new interval
    timerInterval = setInterval(() => {
      
        // Calculate minutes and seconds
        let minutes = Math.floor(countdownDuration / 60);
        let seconds = countdownDuration % 60;

        // Add leading zeros if necessary
        minutes = minutes < 10 ? ((minutes==0)?0:`0${minutes}`) : minutes;
        seconds = seconds < 10 ? ((seconds==0)?0:`0${seconds}`) : seconds;

        // Display the countdown timer
        document.getElementById('timer').innerText = `${minutes}m ${seconds}s`;

        // Decrement the countdown
        countdownDuration--;

        // If the countdown reaches 0, stop the timer
        if (countdownDuration < 0) {
            clearInterval(timerInterval);
            document.getElementById('timer').innerText = "0m 0s";
            timerInterval = null; // Reset the interval variable
        }
    }, 1000); // Update every second
  }
}
// Cart Timer End

// Our Community
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const link = event.target.closest('.our-community-icons a[href^="#"]');

    if (link) {
      event.preventDefault();

      const targetId = link.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offsetTop = targetElement.offsetTop;

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }
  });
});

//  Match Ajax Card Add Product Start
document.addEventListener('DOMContentLoaded', () => {
  // function matchAddtocart(ele){
  //   ele.setAttribute('hidden', 'true');
    
  //   const nextElement = ele.nextElementSibling;
  //   if (nextElement && nextElement.hasAttribute('hidden')) {
  //     nextElement.removeAttribute('hidden');
  //   }
  // }

  // Match Add-to-Cart Event Listener (delegated)
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.match-add-btn');
    if (!button) return;
  
    // Hide the clicked button
    button.classList.add('hidden');
  
    // Show the next element if it's hidden (confirmation or loader)
    const next = button.nextElementSibling;
  
    if (next && next.classList.contains('hidden')) {
      next.classList.remove('hidden'); // ✅ Fix: remove hidden from next element, not button
    }
  });

  document.addEventListener('change', function (e) {
    const select = e.target.closest('.option-select-variant');
    if (!select) return;
  
    optionChange(select);
  });
  
  async function optionChange(element){
    let handle = element.dataset.handle;
    let productData = JSON.parse(document.querySelector(`#match-json-${handle}`).textContent);
  
    const selectOption = document.querySelectorAll(`#option-${handle} .option-select-variant`);
    let optionValue = '';
    let count = 0;
  
    selectOption.forEach(select => {
      optionValue = optionValue ? optionValue + ' / ' + select.value : select.value;
      if (select.value !== "") count++;
    });

    if(selectOption.length == count){
      const selectedVariant = productData.variants.find(variant => variant.title === optionValue);
      // console.log(selectedVariant);
    
      if (selectedVariant) {
        if(selectedVariant.available){
          const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const items = [{ id: Number(selectedVariant.id), quantity: 1 }];
    
          const formData = {
            items,
            sections: cartDrawer?.getSectionsToRender().map(section => section.id),
            sections_url: window.location.pathname,
          };
    
          const { success, data } = await addItemsToCart(formData);
          
          if (!success) return;
          // console.log(success);
          // console.log(data);
        
          // Optionally update cart drawer contents
          if (cartDrawer && data.sections) {
            cartDrawer.renderContents(data);
          }
          // console.log('Product Added to cart...');
        }else{
          // console.log('Selected Variant Soldout...');
        }
      } else {
        // console.log('Selected Variant Unavailable...');
      }
    }
  }
});
//  Match Ajax Card Add Product End

document.addEventListener('DOMContentLoaded', () => {
  // Select all anchor links with href starting with #
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');

      // Skip if it's just "#" (no real target)
      if (targetId.length > 1) {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault(); // stop default jump
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
});

function createReamazeTrigger() {
  // Remove existing trigger if any
  const existing = document.getElementById('reamaze-hidden-trigger');
  if (existing) existing.remove();
  
  // Create new hidden anchor with exact attributes
  const trigger = document.createElement('a');
  trigger.id = 'reamaze-hidden-trigger';
  trigger.href = '#';
  trigger.style.display = 'none';
  trigger.setAttribute('data-reamaze-lightbox', 'contact');
  trigger.setAttribute('data-reamaze-lightbox-anchored', 'true');
  trigger.innerHTML = 'Hidden Chat Trigger'; // Optional text
  
  document.body.appendChild(trigger);
  return trigger;
}

// When Customer scan the QR code link generated with Key Pair Param value
document.addEventListener("Reamazeinit", function () {
  const params = new URLSearchParams(window.location.search);
  const shouldOpenChat =
  params.get("open_chat") === "true" ||
  params.get("reamaze_open") === "true";
  
  if (shouldOpenChat) {
    console.log("reamaze initiated...");
    setTimeout(() => {
      // Reamaze.popup(); // Open chat lightbox
      const trigger = createReamazeTrigger();
      trigger.click();  // Triggers exact same as your working HTML [web:1]
    }, 1000); 
  }
});